export const igCss = `
:root {
  --igp-text: #111827;
  --igp-text-muted: #6b7280;
  --igp-border: #e5e7eb;
  --igp-bg: #ffffff;
  --igp-bg-soft: rgba(0,0,0,0.03);
  --igp-link: #2563eb;
}
.dark :root {
  --igp-text: #e5e7eb;
  --igp-text-muted: #9ca3af;
  --igp-border: #262626;
  --igp-bg: #0a0a0a;
  --igp-bg-soft: rgba(255,255,255,0.06);
  --igp-link: #60a5fa;
}

.igp-container {
  max-width: 672px; /* md/lg-like */
  margin: 0 auto;
  padding: 32px 16px;
}

.igp-card {
  background: var(--igp-bg);
  border: 1px solid var(--igp-border);
  color: var(--igp-text);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

/* Header */
.igp-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
}
.igp-avatar {
  width: 40px; height: 40px;
  border-radius: 999px;
  object-fit: cover;
  flex: 0 0 auto;
}
.igp-header-main { min-width: 0; flex: 1 1 auto; }
.igp-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.igp-name {
  font-weight: 600;
  text-decoration: none;
  color: inherit;
  max-width: 100%;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  cursor: pointer;
}
.igp-name:hover { text-decoration: underline; }
.igp-dot-time {
  font-size: 12px;
  color: var(--igp-text-muted);
}
.igp-more {
  border: 0;
  background: transparent;
  border-radius: 999px;
  padding: 8px;
  cursor: pointer;
}
.igp-more:hover { background: var(--igp-bg-soft); }
.igp-more-icon { width: 20px; height: 20px; fill: currentColor; color: var(--igp-text-muted); }

/* Media */
.igp-media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;          /* key: force square */
  background: var(--igp-bg-soft);
}

.igp-media {
  width: 100%;
  height: 100%;                  /* fill the square */
  object-fit: cover;             /* crop to square */
  max-height: none;              /* override previous max-height */
  display: block;
}
@media (min-width: 640px) {
  .igp-media { object-fit: contain; }
}

/* Actions */
.igp-actions {
  padding: 8px 12px;
}
.igp-actions,
.igp-actions-left {
  display: flex; align-items: center; justify-content: space-between;
}
.igp-actions-left { gap: 12px; justify-content: flex-start; }
.igp-action {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px; margin: -8px;
  border-radius: 999px;
  background: transparent; border: 0; cursor: pointer;
}
.igp-action:hover { background: var(--igp-bg-soft); }
.igp-action-count { font-size: 14px; color: var(--igp-text); }
.igp-save {
  padding: 8px; margin: -8px;
  border-radius: 6px; background: transparent; border: 0; cursor: pointer;
}
.igp-save:hover { background: var(--igp-bg-soft); }

/* Likes */
.igp-likes {
  margin: 8px 12px 0 12px;
  font-size: 14px;
}

/* Caption */
.igp-caption {
  margin: 6px 12px 0 12px;
  font-size: 14px;
  line-height: 1.35;
  word-wrap: break-word;
}
.igp-caption-name { margin-right: 6px; }
.igp-caption-text { white-space: pre-line; }

/* Hashtags */
.igp-tags {
  margin: 6px 12px 0 12px;
  font-size: 14px;
  color: #1d4ed8;
  display: flex; flex-wrap: wrap; gap: 6px 8px;
  max-width: 100%;
}
.dark .igp-tags { color: #60a5fa; }
.igp-tag {
  display: inline-block;
  word-break: break-all;
  text-decoration: none;
}
.igp-tag:hover { text-decoration: underline; }

/* Link note (IG doesn’t show previews) */
.igp-link { color: var(--igp-link); text-decoration: none; }
.igp-link:hover { text-decoration: underline; }
.igp-link-note {
  margin: 6px 12px 0 12px;
  font-size: 12px; color: var(--igp-text-muted);
}

/* View comments + timestamp */
.igp-view-comments {
  margin: 8px 12px 0 12px;
  font-size: 14px;
  color: var(--igp-text-muted);
  background: transparent; border: 0; padding: 0;
  cursor: pointer;
}
.igp-view-comments:hover { text-decoration: underline; }

.igp-timestamp {
  margin: 6px 12px 12px 12px;
  font-size: 11px;
  letter-spacing: .04em;
  color: #9ca3af;
}

/* Links inside caption */
.igp-caption .igp-link { color: var(--igp-link); }
`;
